// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'plug';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 12.938a4.5 4.5 0 0 1-4.5-4.5V5.062a1.125 1.125 0 0 1 1.125-1.124h6.75A1.125 1.125 0 0 1 13.5 5.062v3.375a4.5 4.5 0 0 1-4.5 4.5z' />
    <path d='M6.75 12.335v1.725a1.125 1.125 0 0 0 1.125 1.125h2.25a1.125 1.125 0 0 0 1.125-1.125v-1.725m-4.5-8.397V.562m4.5 3.376V.562M9 15.188v2.25' />
  </g>
);

export const viewBox = '0 0 18 18';
